import React from 'react';
export function Footer() {
  return <footer className="bg-charcoal px-3 py-4 text-center" data-id="element-64" data-mp="32wd2qgad7ltj">
      <div className="mx-auto max-w-3xl space-y-1.5" data-id="element-65" data-mp="3gfiv8kpoaff6">
        <p className="text-[10px] font-medium leading-snug text-mint/70" data-id="element-66" data-mp="3ghc4m7ro7dqv">
          © 2026 FONO KIDS PRO™ — All Rights Reserved. FONO KIDS PRO™ provides educational
          and professional activity resources for qualified speech-language professionals.
          It does not replace professional education, assessment, diagnosis, individualized
          clinical decision-making, supervision, applicable professional standards or
          qualified professional judgment.
        </p>
        <nav aria-label="Legal" className="flex flex-wrap justify-center gap-2 text-[10px] font-bold uppercase tracking-wide text-mint/80" data-id="element-67" data-mp="3le2l2w7e0bct">
          <a href="#" className="transition-colors duration-150 hover:text-mustard" data-id="element-68" data-mp="29y5frxf8retf">
            Terms &amp; Conditions
          </a>
          <span aria-hidden="true" data-id="element-69" data-mp="2ew6z8jgkxg5f">•</span>
          <a href="#" className="transition-colors duration-150 hover:text-mustard" data-id="element-70" data-mp="3l90n1twdyuy7">
            Privacy Policy
          </a>
          <span aria-hidden="true" data-id="element-71" data-mp="3gbqzkjsk4td0">•</span>
          <a href="#" className="transition-colors duration-150 hover:text-mustard" data-id="element-72" data-mp="3gctqustskxtg">
            Contact
          </a>
        </nav>
      </div>
    </footer>;
}